import React from 'react'
import SettingBoxesHead from './SettingBoxesTable/SettingBoxesHead'
import SettingBoxesRow from './SettingBoxesTable/SettingBoxesRow'
import { Empty } from 'antd'

function SettingBoxesTable(props) {
    const { listBoxes, reset } = props

    return (
        <table className='table SettingBoxesTable'>
            <SettingBoxesHead />
            <tbody className='SettingBoxesRow'>
                {listBoxes && listBoxes.length > 0 ? listBoxes.map((item, index) => (
                    <SettingBoxesRow key={index} item={item} reset={reset} />
                )) :
                    <tr>
                        <td colSpan={11}><Empty /></td>
                    </tr>
                }
            </tbody>
        </table>
    )
}

export default SettingBoxesTable